import { Container } from "@mui/material";
import { cn } from "@onair/utils/cn";
import { memo } from "react";
import BoxContentLink from "./box-content-link";

interface CarouselImageProps {
	thumbnailUrl: string | undefined;
	thumbnailAlt?: string;
	title?: string;
	description?: string;
	isActive?: boolean;
	href?: string;
}
const CarouselImage: React.FC<CarouselImageProps> = ({
	thumbnailUrl,
	thumbnailAlt,
	title = "",
	description = "",
	isActive,
	href = "",
}) => {
	return (
		<div className="carousel-item image bg-gray-100 relative">
			<div className="w-full aspect-video">
				{thumbnailUrl ? (
					<img
						src={thumbnailUrl}
						loading="lazy"
						alt={thumbnailAlt || title || "ONAIR thumbnail"}
						className="w-full h-full object-cover object-bottom"
					/>
				) : (
					<div className="empty-image w-full h-full flex items-center justify-center bg-slate-100">
						no image
					</div>
				)}
				<div className="content absolute w-full bottom-0 left-0 right-0 pb-12">
					<Container>
						<BoxContentLink href={href} title={title}>
							<div className="box-content max-w-[660px] text-pretty leading-tight">
								{title && (
									<div
										className="box-content__title text-[28px] md:text-[56px]"
										dangerouslySetInnerHTML={{ __html: title }}
									/>
								)}
								<div
									className={cn(
										"box-content__description text-[12px] md:text-base",
										{
											"mt-3": !!description,
										},
									)}
									dangerouslySetInnerHTML={{ __html: description }}
								/>
							</div>
						</BoxContentLink>
					</Container>
				</div>
			</div>
		</div>
	);
};
export default memo(CarouselImage);
